import React,  { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { CSVLink } from 'react-csv';
import { initiateLogOut } from '../../utils/initiate';
import { toastMessage } from '../../utils/toast';
import * as reportActions from '../../Redux/Actions/report';
import * as commonActions from '../../Redux/Actions/common';
import Warning from '../Ui/400';
import { useSortableData } from '../../utils/sortableData';
import ReactPaginate from 'react-paginate';

const Reports = ({ history }) => {

    const [clearFilter, setClearFilter] = useState(false);
    const [data, setData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [staffName, setStaffName] = useState('');
    const [processName, setProcessName] = useState('');
    const [jobStatus, setJobStatus] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [staffNameData, setStaffNameData] = useState([]);
    const [processNameData, setProcessNameData] = useState([]);
    const [jobStatusData, setJobStatusData] = useState([]);
    const [customerNameData, setCustomerNameData] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const pageLoading = useSelector(({Common}) => Common.pageLoading);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    let itemsPerPage = 10;
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        dispatch(commonActions.pageLoading(true));
        let payload = {
            customerName: (customerName === '') ? null : customerName, staffName: (staffName === '') ? null : staffName, processName: (processName === '') ? null : processName, jobStatus: (jobStatus === '') ? null : jobStatus
        };
        let filterSelected = ((customerName === '') && (staffName === '') && (processName === '') && (jobStatus === ''));
        let apiType = (userData.Role !== 'TYPINGCENTERSTAFF') ? 'getAllAdminJobs' : 'getAllStaffJobs';
        reportActions[apiType](filterSelected ? {} : payload).then(res => {
            if(res && res.data){
                let reportData = res.data;
                setData(reportData);
                filterData(reportData);
                let csvDataFormat = [];
                if (userData.Role === 'TYPINGCENTERSTAFF') {
                    csvDataFormat = reportData.map(({jobInfo, customerInfo}, index) => ({'S No': index+1, 'Job ID': jobInfo.jobId, Customer: customerInfo, Process: jobInfo.processName, 'Transaction Amount': jobInfo.transactionAmount, 'Transaction Status': jobInfo.transactionStatus, Status: jobInfo.status}));
                } else {
                    csvDataFormat = reportData.map(({jobInfo, customerInfo, staffInfo}, index) => ({'S No': index+1, 'Job ID': jobInfo.jobId, Customer: customerInfo, Process: jobInfo.processName, Staff: staffInfo, 'Transaction Amount': jobInfo.transactionAmount, 'Transaction Status': jobInfo.transactionStatus, Status: jobInfo.status}));
                }
                setCsvData(csvDataFormat);
            }else{
                toastMessage('error', 'Unable to load the jobs');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            dispatch(commonActions.pageLoading(false));
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, staffName, processName, jobStatus, customerName]);

    const filterData = (reportData) => {
        let staffData = reportData.map(({staffInfo}) => ({staffInfo}));
        let processData = reportData.map(({jobInfo}) => ({processName: jobInfo.processName}));
        let statusData = reportData.map(({jobInfo}) => ({status: jobInfo.status}));
        let customerData = reportData.map(({customerInfo}) => ({customerInfo}));

        staffData = staffData.filter((v,i,a)=>a.findIndex(t=>(t.staffInfo === v.staffInfo)) === i);
        processData = processData.filter((v,i,a)=>a.findIndex(t=>(t.processName === v.processName)) === i);
        statusData = statusData.filter((v,i,a)=>a.findIndex(t=>(t.status === v.status)) === i);
        customerData = customerData.filter((v,i,a)=>a.findIndex(t=>(t.customerInfo === v.customerInfo)) === i);

        setStaffNameData(staffData);
        setProcessNameData(processData);
        setJobStatusData(statusData);
        setCustomerNameData(customerData);
    };

    const {items, requestSort, sortConfig} = useSortableData(data);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title">{t("reports.title")}</h4>
            </div>
            <div className="container-fluid">
                {pageLoading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} /></div>
                :   <div className="card-body py-3 p-0">
                <div className="tab-content">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex">
                            {(userData.Role !== 'TYPINGCENTERSTAFF') && <select className="form-select status_change me-3" value={staffName} onChange={e => {setStaffName(e.target.value); setClearFilter(false)}}>
                                <option value="" disabled={true}>{t("reports.filters.selectStaff")}</option>
                                {staffNameData.map(({staffInfo}) => <option key={staffInfo} value={staffInfo}>{staffInfo}</option>)}
                            </select>}
                            <select className="form-select status_change me-3" value={processName} onChange={e => {setProcessName(e.target.value); setClearFilter(false)}}>
                                <option value="" disabled={true}>{t("reports.filters.selectProcess")}</option>
                                {processNameData.map(({processName}) => <option key={processName} value={processName}>{processName}</option>)}
                            </select>
                            <select className="form-select status_change me-3" value={jobStatus} onChange={e => {setJobStatus(e.target.value); setClearFilter(false)}}>
                                <option value="" disabled={true}>{t("reports.filters.selectJobStatus")}</option>
                                {jobStatusData.map(({status}) => <option key={status} value={status}>{status}</option>)}
                            </select>
                            <select className="form-select status_change me-3" value={customerName} onChange={e => {setCustomerName(e.target.value); setClearFilter(false)}}>
                                <option value="" disabled={true}>{t("reports.filters.selectCustomer")}</option>
                                {customerNameData.map(({customerInfo}) => <option key={customerInfo} value={customerInfo}>{customerInfo}</option>)}
                            </select>
                            <div className="d-flex align-items-center" style={{whiteSpace: 'nowrap'}}>
                                <input id="clearFilter" className="me-1" type="checkbox" checked={clearFilter} onChange={e => {setClearFilter(e.target.checked); setStaffName(''); setProcessName(''); setJobStatus(''); setCustomerName('');}} /> 
                                <label htmlFor="clearFilter">{t("reports.filters.clearFilters")}</label>
                            </div>
                        </div>
                        <CSVLink data={csvData} filename={"csp_portal_reports.csv"} className="btn btn-primary">{t("reports.filters.download")}</CSVLink>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-head-custom table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="c-pointer pl-7" style={{width: '80px'}} onClick={() => requestSort('sno')}>
                                        <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-secondary" : "text-dark-75"}>{t("reports.manageReports.sNo")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                    </th>
                                    <th className="c-pointer" style={{width: '50px'}} onClick={() => requestSort('jobId')}><span className={(sortConfig && (sortConfig.key === 'jobId')) ? "text-secondary" : "text-dark-75"}>{t("reports.manageReports.id")} {(sortConfig && (sortConfig.key === 'jobId')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="c-pointer" style={{width: '80px'}} onClick={() => requestSort('customerInfo')}><span  className={(sortConfig && (sortConfig.key === 'customerInfo')) ? "text-secondary" : "text-dark-75"}>{t("reports.manageReports.user")} {(sortConfig && (sortConfig.key === 'customerInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="c-pointer" style={{minWidth: '100px'}} onClick={() => requestSort('process')}><span  className={(sortConfig && (sortConfig.key === 'process')) ? "text-secondary" : "text-dark-75"}>{t("reports.manageReports.process")} {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    {(userData.Role !== 'TYPINGCENTERSTAFF') && <th className="c-pointer" style={{minWidth: '100px'}} onClick={() => requestSort('staffInfo')}><span className={(sortConfig && (sortConfig.key === 'staffInfo')) ? "text-primary" : "text-dark-75"}>{t("reports.manageReports.staff")} {(sortConfig && (sortConfig.key === 'staffInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>}
                                    <th style={{minWidth: '100px'}} className="c-pointer" onClick={() => requestSort('transactionAmount')}><span className={(sortConfig && (sortConfig.key === 'transactionAmount')) ? "text-secondary" : "text-dark-75"}>{t("reports.manageReports.transactionAmount")} {(sortConfig && (sortConfig.key === 'transactionAmount')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.transactionStatus")}</span></th>
                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.status")}</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map(({customerInfo, jobInfo, staffInfo}, index) => {
                                    return(
                                        <tr key={index}>
                                            <td className="pl-7">
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.jobId}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{customerInfo}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.processName}</span>
                                            </td>
                                            {(userData.Role !== 'TYPINGCENTERSTAFF') && <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{staffInfo}</span>
                                            </td>}
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.transactionAmount}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.transactionStatus}</span>
                                            </td>
                                            <td style={{whiteSpace: 'nowrap'}}>
                                                <span className={"p-2 badge badge-outline-purple"} style={{borderRadius: '3px', width: 'auto'}}>{jobInfo.status}</span>
                                            </td>
                                        </tr>
                                    )})}
                            </tbody>
                        </table>
                        {(pageCount > 1) && <ReactPaginate
                            breakLabel="..."
                            nextLabel=">"
                            previousLabel="<"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            containerClassName="pagination"
                            activeClassName="active"
                            renderOnZeroPageCount={null}
                        />}
                        {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("reports.noDataAvailable")}</p>}
                    </div>
                </div>
            </div>}
            </div>
        </div>
    );
};

export default Reports;